<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <v-btn color="secondary" icon v-on="{ ...tooltip }" @click.stop="dialog = true">
                    <v-icon dark>zoom_in</v-icon>
                </v-btn>
            </template>
            <span>Show task outcome</span>
        </v-tooltip>
        <v-dialog max-width="700" v-model="dialog" persistent>
            <v-card>
                <v-card-title class="flex-nowrap align-start">
                    <div class="secondary--text">Task outcome</div>

                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false" icon><v-icon>clear</v-icon></v-btn>
                </v-card-title>

                <v-card-text>
                    <v-card-text>
                        <div v-html="message"></div>
                    </v-card-text>
                </v-card-text>
                <v-card-actions></v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'UserTaskOutcome',
    props: {
        message: String
    },
    data() {
        return {
            dialog: false
        }
    }
}
</script>
